/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiStatusCodeLookup.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-status-code-lookup";

export class AutogenModelEdiStatusCodeLookup<RowType extends ModelRow> extends Endpoint<RowType, RowEdiStatusCodeLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiStatusCodeLookup extends ModelRow<RowEdiStatusCodeLookupFields> {
	constructor(values?: Partial<RowEdiStatusCodeLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiStatusCodeLookupFields {
	company_id: string;
	description: string;
	element_id: string;
	standard_code: string;
	version: string;
}

